module.exports = __webpack_public_path__ + "media/images/distilation-mobile-bf9d170962d8d2d9a16a139d0d70c26b.jpg";